import axios from "axios";

// Separater API-Client für das Kundenportal (eigener JWT im localStorage).
const portalApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/portal`,
});

portalApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("popcrn_portal_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

portalApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("popcrn_portal_token");
      localStorage.removeItem("popcrn_portal_customer");
      if (!window.location.pathname.endsWith("/portal/login")) {
        window.location.href = "/portal/login";
      }
    }
    return Promise.reject(err);
  }
);

export default portalApi;
